import { render, staticRenderFns } from "./step_04.vue?vue&type=template&id=0a194d9d&scoped=true"
import script from "./step_04.vue?vue&type=script&lang=js"
export * from "./step_04.vue?vue&type=script&lang=js"
import style0 from "./step_04.vue?vue&type=style&index=0&id=0a194d9d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a194d9d",
  null
  
)

export default component.exports